import * as R from 'ramda'
import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Header, Modal, Progress } from 'semantic-ui-react'
import styled from 'styled-components'
import { CertificateButton } from '../../organisms/CertificateButton/index'
import { EbibButton } from '../../organisms/EbibButton/index'
import { endSubmitRun, formatDateTime, startSubmitRun } from '../../utils/index'
import { calculateProgress } from './utils'
import { getParticipantUnit } from '../../utils/run'

const sumDistance = participant => {
  const distance = participant.runs
    .map(each => each.status === 'approve' && each.distance)
    .reduce((prev, next) => prev + next, 0)
    .toFixed(2)
  if (participant.race_detail.race.is_walk) {
    return parseInt(distance)
  } else {
    return distance
  }
}

const StyledCard = styled.div.attrs({
  className: 'ui centered card mobile-not-show'
})`
  && {
    width: 90%;
    margin-bottom: 15px;
  }
`

export const ParticipantCard = ({
  participant,
  race,
  featureImage,
  bib,
  finish_run,
  collect_distance,
  runs,
  distanceName,
  title,
  registerDate,
  raceDate,
  participantId,
  payment,
  is_paid,
  submitDate
}) => (
  <React.Fragment>
    <StyledCard>
      <div className="ui image">
        <img src={featureImage} />
      </div>
      <div className="content">
        {startSubmitRun(race) && (
          <React.Fragment>
            <Progress
              percent={calculateProgress(participant)}
              indicating
              style={{ marginBottom: 10 }}
            />
            <div style={{ marginTop: 10, textAlign: 'center' }}>
              <h2 style={{ textAlign: 'center' }}>
                {calculateProgress(participant)}%{' '}
                {calculateProgress(participant) < 100 ? 'Loading' : 'Complete'}{' '}
                {`(${sumDistance(participant)} ${getParticipantUnit(
                  participant
                )})`}
              </h2>
              {calculateProgress(participant) >= 100 && (
                <React.Fragment>
                  {participant.race_detail.race.collect_distance && (
                    <Link
                      to={`/races/${race.slug}/ranking`}
                      style={{ display: 'none' }}
                    >
                      <Button className="mr-10" color="teal">
                        ผลการจัดอันดับ
                      </Button>
                    </Link>
                  )}
                  <EbibButton participant={participant} />
                  {!endSubmitRun(race) &&
                    participant.race_detail.race.collect_distance && (
                      <Link to="/submit-run">
                        <Button color="teal" className="mr-10">
                          ส่งผลวิ่ง / เดิน
                        </Button>
                      </Link>
                    )}
                  {participant.certificate && (
                    <CertificateButton certificate={participant.certificate} />
                  )}
                </React.Fragment>
              )}
            </div>
          </React.Fragment>
        )}
        <div
          className="right floated"
          style={{ marginTop: 40, width: '35%', textAlign: 'center' }}
        >
          {(startSubmitRun(race) && !runs.length && is_paid) ||
          finish_run ? null : (
            <p
              style={{
                fontWeight: 'bold',
                fontSize: '1.5em',
                marginBottom: 0
              }}
            >
              {!runs.length && <span style={{ color: 'black' }}>สถานะ:</span>}
              {startSubmitRun(race) &&
              !finish_run &&
              is_paid &&
              !participant.race_detail.race.collect_distance &&
              runs.filter(each => each.status === 'not_approve').length ? (
                <Link to="/run-status">
                  <span style={{ color: '#f0bb40' }}>หลักฐานไม่อนุมัติ</span>
                </Link>
              ) : startSubmitRun(race) && !finish_run && is_paid ? (
                <Link to="/run-status">
                  <Button fluid color="teal" className="mr-10">
                    ตรวจสอบสถานะผลวิ่ง
                  </Button>
                </Link>
              ) : !is_paid && R.pathOr(null, ['approve'], payment) === null ? (
                <span style={{ color: 'red' }}> รอชำระเงิน</span>
              ) : !R.path(['approve'], payment) && !is_paid ? (
                <span style={{ color: '#f0bb40' }}>
                  {' '}
                  รอตรวจสอบหลักฐานการชำระเงิน
                </span>
              ) : R.path(['approve'], payment) || is_paid ? (
                <span style={{ color: 'green' }}> ชำระเงินแล้ว</span>
              ) : null}
            </p>
          )}
          {startSubmitRun(race) &&
          !runs.length &&
          is_paid &&
          !endSubmitRun(race) ? (
            <div>
              <div style={{ marginTop: -10 }}>
                <Link to="/submit-run">
                  <Button fluid color="teal" className="mr-10">
                    ส่งผลวิ่ง / เดิน
                  </Button>
                </Link>
              </div>
              <div className="mt10">
                <EbibButton participant={participant} fluid />
              </div>
              {participant.race_detail.race.collect_distance && (
                <div>
                  <Link
                    to={`/races/${race.slug}/ranking`}
                    style={{ display: 'none' }}
                  >
                    <Button fluid className="mt10" color="teal">
                      ผลการจัดอันดับ
                    </Button>
                  </Link>
                </div>
              )}
            </div>
          ) : startSubmitRun(race) &&
            !finish_run &&
            is_paid &&
            !endSubmitRun(race) ? (
            <div style={{ marginTop: 10 }}>
              <div>
                <Link to="/submit-run">
                  <Button fluid color="teal" className="mr-10">
                    ส่งผลวิ่ง / เดิน
                  </Button>
                </Link>
              </div>
              {participant.race_detail.race.collect_distance && (
                <div>
                  <Link
                    to={`/races/${race.slug}/ranking`}
                    style={{ display: 'none' }}
                  >
                    <Button fluid className="mt10" color="teal">
                      ผลการจัดอันดับ
                    </Button>
                  </Link>
                </div>
              )}
              <div className="mt10">
                <EbibButton fluid participant={participant} />
              </div>
            </div>
          ) : (
            <div>
              {!is_paid && !race.close_registration ? (
                <div style={{ marginTop: 10 }}>
                  <Link to={`/participants/payment/${participantId}`}>
                    <Button color="teal">ชำระเงิน</Button>
                  </Link>
                  <Link to="/confirm-payment">
                    <Button className="ml-10" color="teal">
                      แจ้งโอนเงิน
                    </Button>
                  </Link>
                  {participant.race_detail.is_free && (
                    <div className="mt10">
                      <EbibButton participant={participant} />
                    </div>
                  )}
                </div>
              ) : !is_paid && race.close_registration ? (
                <Button className="ml-10" color="red">
                  ปิดรับสมัคร
                </Button>
              ) : (R.path(['approve'], payment) && !finish_run) ||
                (is_paid && !finish_run) ? (
                <EbibButton participant={participant} />
              ) : null}
            </div>
          )}
        </div>
        <div>
          <h1>{title}</h1>
          <p>
            <span style={{ fontWeight: 'bold' }}>
              {participant.race_detail.race.is_walk
                ? 'จำนวนก้าวที่สมัคร'
                : 'ระยะทางที่สมัคร'}
            </span>
            : {distanceName}
          </p>
          <p>
            <span style={{ fontWeight: 'bold' }}>ประเภทของกิจกรรม:</span>{' '}
            {participant.race_detail.race.is_walk
              ? 'เดินเก็บระยะก้าว'
              : participant.race_detail.race.collect_distance
              ? 'วิ่งแบบสะสมระยะ'
              : 'วิ่งแบบครั้งเดียวจบ'}
          </p>
          {!startSubmitRun(race) && (
            <p>
              <span style={{ fontWeight: 'bold' }}>วันเปิดรับสมัคร</span>:{' '}
              {registerDate} (หรือจนกว่าจะเต็มจำนวน)
            </p>
          )}

          <p>
            <span style={{ marginTop: '5', fontWeight: 'bold' }}>
              วันแข่งขัน:{' '}
            </span>
            {raceDate}
          </p>
          <p>
            <span style={{ marginTop: '5', fontWeight: 'bold' }}>
              วันส่งผลการแข่งขัน:{' '}
            </span>
            {submitDate}
          </p>
          <p>
            <span style={{ marginTop: '5', fontWeight: 'bold' }}>
              วันสิ้นสุดกิจกรรม:{' '}
            </span>
            {formatDateTime(race.last_submit_time)}
          </p>
          <p>
            <span style={{ marginTop: '5', fontWeight: 'bold' }}>
              ช่วงเวลาจัดส่งของที่ระลึก:{' '}
            </span>
            ภายใน 10 วันทำการ หลังสิ้นสุดกิจกรรม
          </p>
          <p>
            <Link
              to={`/participants/payment/${participantId}`}
              style={{ fontWeight: 'normal' }}
            >
              <u>ดูรายการสั่งซื้อ</u>
            </Link>
            {!participant.is_paid && (
              <span>
                {' '}
                |{' '}
                <Link
                  to={`/participants/${participantId}/edit`}
                  style={{ fontWeight: 'normal' }}
                >
                  <u>แก้ไขคำสั่งซื้อ</u>
                </Link>
              </span>
            )}
            {participant.tracking && (
              <Modal
                trigger={
                  <span>
                    {` `}|{` `}
                    <Link to="#" style={{ fontWeight: 'normal' }}>
                      <u>ติดตามสถานะเหรียญ</u>
                    </Link>
                  </span>
                }
              >
                <Header icon="archive" content="เลขพัสดุ" />
                <Modal.Content>
                  <p>{participant.tracking}</p>
                  <p>
                    กรุณานำเลขพัสดุไปกรอกในเว็บไปรษณีย์ไทยเพื่อ เช็คสถานะการส่ง
                  </p>
                </Modal.Content>
                <Modal.Actions>
                  <a
                    href="http://track.thailandpost.co.th/tracking/result.aspx"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button color="olive">ไปรษณีย์ไทย</Button>
                  </a>
                </Modal.Actions>
              </Modal>
            )}
          </p>
        </div>
      </div>
    </StyledCard>
  </React.Fragment>
)

const StyledMobileCard = styled.div.attrs({
  className: 'ui centered card'
})`
  && {
    display: none;
    @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
      display: flex;
      width: 90%;
      margin-bottom: 15px;
      box-shadow: none;
    }
  }
`

export const MobileParticipantCard = ({
  participant,
  bib,
  finish_run,
  collect_distance,
  runs,
  distanceName,
  featureImage,
  title,
  race,
  registerDate,
  raceDate,
  submitDate,
  participantId,
  payment,
  is_paid
}) => (
  <React.Fragment>
    <StyledMobileCard>
      <div className="ui image">
        <img src={featureImage} />
      </div>
      <div className="content" />
      {startSubmitRun(race) && (
        <React.Fragment>
          <Progress
            percent={calculateProgress(participant)}
            indicating
            style={{ marginBottom: 10 }}
          />
          <div style={{ textAlign: 'center' }}>
            <h3 style={{ textAlign: 'center' }}>
              {calculateProgress(participant)}%{' '}
              {calculateProgress(participant) < 100 ? 'Loading' : 'Complete'}{' '}
              {`(${sumDistance(participant)} ${getParticipantUnit(
                participant
              )})`}
            </h3>
            {calculateProgress(participant) >= 100 && (
              <React.Fragment>
                {participant.race_detail.race.collect_distance && (
                  <Link
                    to={`/races/${race.slug}/ranking`}
                    style={{ display: 'none' }}
                  >
                    <Button
                      className="mr-10"
                      style={{ width: '100%' }}
                      color="teal"
                    >
                      ผลการจัดอันดับ
                    </Button>
                  </Link>
                )}
                <EbibButton participant={participant} />
                {!endSubmitRun(race) &&
                  participant.race_detail.race.collect_distance && (
                    <Link to="/submit-run">
                      <Button fluid color="teal" className="mr-10 mt10">
                        ส่งผลวิ่ง / เดิน
                      </Button>
                    </Link>
                  )}
                {participant.certificate && (
                  <CertificateButton certificate={participant.certificate} />
                )}
              </React.Fragment>
            )}
          </div>
        </React.Fragment>
      )}
      <div>
        <h1>{title}</h1>
        <p>
          <p style={{ fontWeight: 'bold' }}>
            {race.is_walk ? 'จำนวนก้าวที่สมัคร' : 'ระยะทางที่สมัคร'}:{' '}
          </p>
          {distanceName}
        </p>
        <p>
          <p style={{ fontWeight: 'bold' }}>ประเภทของกิจกรรม: </p>
          {race.is_walk
            ? 'เดินเก็บระยะก้าว'
            : race.collect_distance
            ? 'วิ่งแบบสะสมระยะ'
            : 'วิ่งแบบครั้งเดียวจบ'}
        </p>
        {!startSubmitRun(race) && (
          <p>
            <span style={{ fontWeight: 'bold' }}>วันเปิดรับสมัคร</span>:{' '}
            {registerDate} (หรือจนกว่าจะเต็มจำนวน)
          </p>
        )}
        <p>
          <p style={{ marginTop: '5', fontWeight: 'bold' }}>วันแข่งขัน: </p>
          {raceDate}
        </p>
        <p>
          <p style={{ marginTop: '5', fontWeight: 'bold' }}>
            วันส่งผลการแข่งขัน:{' '}
          </p>
          {submitDate}
        </p>
        <p>
          <p style={{ marginTop: '5', fontWeight: 'bold' }}>
            วันสิ้นสุดกิจกรรม:{' '}
          </p>
          {formatDateTime(race.last_submit_time)}
        </p>
        <p>
          <p style={{ marginTop: '5', fontWeight: 'bold' }}>
            ช่วงเวลาจัดส่งของที่ระลึก:{' '}
          </p>
          ภายใน 10 วันทำการ หลังสิ้นสุดกิจกรรม
        </p>
        <p>
          <Link
            to={`/participants/payment/${participantId}`}
            style={{ fontWeight: 'normal' }}
          >
            <u>ดูรายการสั่งซื้อ</u>
          </Link>
        </p>
        {!participant.is_paid && (
          <p>
            <Link
              to={`/participants/${participantId}/edit`}
              style={{ fontWeight: 'normal' }}
            >
              <u>แก้ไขคำสั่งซื้อ</u>
            </Link>
          </p>
        )}
        {participant.tracking && (
          <React.Fragment>
            <Modal
              trigger={
                <p>
                  <Link to="#" style={{ fontWeight: 'normal' }}>
                    <u>ติดตามสถานะเหรียญ</u>
                  </Link>
                </p>
              }
            >
              <Header icon="archive" content="เลขพัสดุ" />
              <Modal.Content>
                <p>{participant.tracking}</p>
                <p>
                  กรุณานำเลขพัสดุไปกรอกในเว็บไปรษณีย์ไทยเพื่อ เช็คสถานะการส่ง
                </p>
              </Modal.Content>
              <Modal.Actions>
                <a
                  href="http://track.thailandpost.co.th/tracking/result.aspx"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button style={{ marginBottom: 15 }} color="olive">
                    ไปรษณีย์ไทย
                  </Button>
                </a>
              </Modal.Actions>
            </Modal>
          </React.Fragment>
        )}
      </div>
      <div style={{ marginTop: 20, textAlign: 'center' }}>
        {(startSubmitRun(race) && !runs.length && is_paid) ||
        finish_run ? null : (
          <p style={{ fontWeight: 'bold', fontSize: '1em', marginBottom: 0 }}>
            {!runs.length && <span style={{ color: 'black' }}>สถานะ:</span>}

            {startSubmitRun(race) &&
            !finish_run &&
            is_paid &&
            !participant.race_detail.race.collect_distance &&
            runs.filter(each => each.status === 'not_approve').length ? (
              <Link to="/run-status">
                <span style={{ color: '#f0bb40' }}>หลักฐานไม่อนุมัติ</span>
              </Link>
            ) : startSubmitRun(race) && !finish_run && is_paid ? (
              <Link to="/run-status">
                <Button fluid color="teal" className="mr-10">
                  ตรวจสอบสถานะผลวิ่ง
                </Button>
              </Link>
            ) : !is_paid && R.pathOr(null, ['approve'], payment) === null ? (
              <span style={{ color: 'red' }}> รอชำระเงิน</span>
            ) : !R.path(['approve'], payment) && !is_paid ? (
              <span style={{ color: '#f0bb40' }}>
                {' '}
                รอตรวจสอบหลักฐานการชำระเงิน
              </span>
            ) : R.path(['approve'], payment) || is_paid ? (
              <span style={{ color: 'green' }}> ชำระเงินแล้ว</span>
            ) : null}
          </p>
        )}
        {startSubmitRun(race) &&
        !runs.length &&
        is_paid &&
        !endSubmitRun(race) ? (
          <React.Fragment>
            <Link to="/submit-run">
              <Button color="teal" className="mt10" style={{ width: '100%' }}>
                ส่งผลวิ่ง / เดิน
              </Button>
            </Link>
            <EbibButton participant={participant} />
            {participant.race_detail.race.collect_distance && (
              <Link
                to={`/races/${race.slug}/ranking`}
                style={{ display: 'none' }}
              >
                <Button color="teal" className="mt10" style={{ width: '100%' }}>
                  ผลการจัดอันดับ
                </Button>
              </Link>
            )}
          </React.Fragment>
        ) : startSubmitRun(race) &&
          !finish_run &&
          is_paid &&
          !endSubmitRun(race) ? (
          <React.Fragment>
            <div>
              <Link to="/submit-run">
                <Button fluid color="teal" className="mt10">
                  ส่งผลวิ่ง / เดิน
                </Button>
              </Link>
            </div>
            {participant.race_detail.race.collect_distance && (
              <Link
                to={`/races/${race.slug}/ranking`}
                style={{ display: 'none' }}
              >
                <Button
                  color="teal"
                  className="mt10"
                  style={{ width: '100%', display: 'none' }}
                >
                  ผลการจัดอันดับ
                </Button>
              </Link>
            )}
            <EbibButton participant={participant} />
          </React.Fragment>
        ) : (
          <React.Fragment>
            {!is_paid && !race.close_registration ? (
              <React.Fragment>
                <Link to={`/participants/payment/${participantId}`}>
                  <Button
                    color="teal"
                    className="mt10"
                    style={{ width: '100%' }}
                  >
                    ชำระเงิน
                  </Button>
                </Link>
                <Link to="/confirm-payment">
                  <Button
                    color="teal"
                    className="mt10"
                    style={{ width: '100%' }}
                  >
                    แจ้งโอนเงิน
                  </Button>
                </Link>
                {participant.race_detail.is_free && (
                  <EbibButton participant={participant} />
                )}
              </React.Fragment>
            ) : !is_paid && race.close_registration ? (
              <Button className="mt10" color="red" style={{ width: '100%' }}>
                ปิดรับสมัคร
              </Button>
            ) : (R.path(['approve'], payment) && !finish_run) || is_paid ? (
              <EbibButton participant={participant} />
            ) : null}
          </React.Fragment>
        )}
      </div>
    </StyledMobileCard>
  </React.Fragment>
)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/ParticipantCard/index.js